import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_onboarding-search_page_highlighted_product-view';

/**
 * this event tracks whether a retailer who navigated back to the search page with the "return to results" product page button sees their product highlighted on the first page.
 */
export function trackRetailerOnboardingSearchPageHighlightedProductView(
  productWasHighlighted: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { productWasHighlighted },
  });
}
